import styled from '@emotion/styled'

import mq from 'styles/breakpoints'
import HeaderGirl from 'images/jpg/products-header-girl-city.jpg'
import ManWithGlobe from 'images/jpg/hispanicmanwithglobe.jpg'

export const BackgroundImageContainer = styled.div`
  background-image: url(${HeaderGirl});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  padding-top: 44.299%;

  ${mq['lg']} {
    margin-top: -7rem;
  }

  ${mq['sm']} {
    height: 100vh;
    background-position: 60%;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  margin-top: -35%;
  margin-left: 13.5%;
  text-shadow: black 1px 1px 5px;
  color: white;

  h1 {
    font-size: 6.2rem;
    font-weight: 400;
  }

  h4 {
    padding-top: 2rem;
    font-size: 3rem;
    font-weight: 400;
  }

  ${mq['xl']} {
    width: 80%;
    margin-left: 5%;

    h1 {
      font-size: 5rem;
    }

    h4 {
      font-size: 2.5rem;
    }
  }

  ${mq['md']} {
    text-align: center;

    h1 {
      font-size: 3rem;
    }

    h4 {
      font-size: 1.5rem;
    }
  }

  ${mq['sm']} {
    justify-content: center;
    align-items: center;
    margin-top: 1px;
    width: 95%;
    padding-right: 2%;
    height: 100%;

    h4 {
      width: 95%;
    }
  }
`

export const AcademySection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-top: 5rem;
  margin-left: 10%;
  padding-top: 5rem;
  padding-bottom: 0rem;
  color: #213054;

  ${mq['xxl']} {
    justify-content: space-around;
  }

  ${mq['md']} {
    width: 100%;
    margin-left: 0%;
  }
`

export const HeaderTitle = styled.div`
  width: 100%;
  text-align: center;
  padding-bottom: 5rem;
  margin-top: 1rem;

  h1 {
    font-size: 8rem;
    color: #213054;
  }

  h2 {
    font-size: 4rem;
  }

  ${mq['xxl']} {
    h1 {
      font-size: 6.5rem;
    }

    h2 {
      font-size: 4rem;
    }
  }

  ${mq['xl']} {
    h1 {
      font-size: 5.5rem;
    }
  }

  ${mq['sm']} {
    h1 {
      font-size: 3rem;
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: rgb(250, 250, 250);

  ${mq['md']} {
    flex-direction: column;
    padding-bottom: 5rem;
  }
`

export const ImageContainer = styled.div`
  max-width: max-content;

  img {
    max-width: 100%;
  }
`

export const AcademyTextContainer = styled.div`
  margin-left: 20px;
  max-height: 812px;
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: 10rem;
  margin-bottom: 0rem;

  ${mq['lg']} {
    justify-content: space-around;
  }
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  padding-left: 3rem;
  padding-right: 5rem;
  padding-top: 0rem;
  display: inline;

  h1 {
    display: inline;
    padding-right: 1rem;
    font-size: 6rem;
    font-weight: 300;
    color: #b9b9b9;
  }

  h3 {
    display: inline-flex;
    font-size: 2rem;
  }

  p {
    font-size: 2rem;
    padding-left: 5rem;
    padding-bottom: 5rem;
  }

  h6 {
    font-size: 4rem;
    color: #0080fa;
    margin-top: 2rem;
  }

  h5 {
    color: #0080fa;
    font-size: 2.1rem;
    margin-top: 1.5rem;
    margin-left: 0.5rem;
  }

  ${mq['lg']} {
    margin-right: 0;
    margin-bottom: 5rem;
    width: 33rem;

    h6 {
      font-size: 3.5rem;
    }

    p {
      font-size: 2.5rem;
    }

    h5 {
      font-size: 1.8rem;
    }
  }

  ${mq['md']} {
    margin-right: 0;
    margin-bottom: 5rem;
    width: 33rem;

    h6 {
      font-size: 3rem;
    }

    p {
      font-size: 2.2rem;
    }

    h5 {
      font-size: 1.7rem;
    }
  }

  ${mq['sm']} {
    margin-right: 0;
    margin-bottom: 5rem;
    width: 28rem;

    h6 {
      font-size: 2.5rem;
    }

    p {
      font-size: 1.8rem;
      height: 16rem;
    }

    h5 {
      font-size: 1.5rem;
    }
  }
`

export const FeatureSection = styled.section`
  display: flex;
  flex-direction: column;
  background-color: rgb(250, 250, 250);
  width: 100%;
  margin-left: 0%;
  margin-top: 3rem;
  padding-top: 3em;
  margin-bottom: 0rem;
  padding-bottom: 5rem;

  ${mq['xxl']} {
    justify-content: space-around;
    margin-top: 10rem;
  }

  ${mq['md']} {
    flex-direction: column;
    align-items: center;
    margin-top: 0rem;
    width: 100%;
    margin-left: 0%;
  }
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-top: 5rem;
  ${mq['md']} {
    flex-direction: column;
  }
`

export const RightContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  padding-right: 3%;

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  ${mq['md']} {
    padding-left: 3%;
  }

  ${mq['sm']} {
    padding-left: 3%;

    img {
      width: 35em;
      max-width: 100%;
      height: auto;
    }
  }
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  height: 100%;
  color: #213054;
  margin-left: 5rem;
  margin-right: 5rem;
  font-size: 2rem;
  text-align: left;
  font-weight: 400;
`

export const FeaturesTextContainer = styled.div`
  width: 100%;

  h3 {
    font-size: 2.5rem;
    font-weight: 700;
    width: 100%;
  }

  p {
    margin-bottom: 4rem;
  }

  span {
    font-size: 2rem;
    font-weight: 300;
    text-align: left;
    width: 100%;
    color: #0080fa;
  }

  ${mq['xxl']} {
    width: 80%;
    font-size: 1.75rem;

    h3 {
      font-size: 2rem;
    }
  }

  ${mq['xl']} {
    width: 100%;
  }

  ${mq['md']} {
    margin-top: 5rem;
    width: 40rem;
    padding-bottom: 5rem;
  }

  ${mq['sm']} {
    margin-top: 5rem;
    width: 25rem;
    padding-bottom: 5rem;
  }
`

export const RightRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${mq['md']} {
    flex-direction: column;
  }
`

export const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 5rem;

  img {
    align-self: left;
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  ${mq['md']} {
    padding-right: 5rem;
  }

  ${mq['sm']} {
    img {
      align-self: center;
      height: auto;
    }
  }
`

export const RightRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 75%;
  color: #213054;
  margin-left: 5rem;
  margin-right: 5rem;
  font-size: 2rem;
  text-align: right;
  font-weight: 400;
`

export const FunctionsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(26, 26, 26);
  width: 90%;
  margin-left: 5%;
  padding-top: 10rem;
  padding-bottom: 10rem;

  ${mq['xxl']} {
    justify-content: space-around;
  }
`

export const IconContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: -12rem;
  justify-content: center;

  img {
    width: 300px;
  }

  ${mq['xsm']} {
    img {
      width: 200px;
    }
  }
`

export const FunctionsTextContainer = styled.div`
  text-align: center;
  padding-bottom: 5rem;

  h1 {
    font-size: 7rem;
    color: rgb(255, 255, 255);
  }

  h2 {
    font-size: 4rem;
  }

  ${mq['xxl']} {
    h1 {
      font-size: 4.5rem;
    }

    h2 {
      font-size: 4rem;
    }
  }
`

export const FunctionsImageContainer = styled.div`
  img {
    max-width: 100%;
    height: auto;
  }
`

export const TestimoniesSection = styled.section`
  background-color: rgb(250, 250, 250);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #213054;
  margin-top: 20rem;
  padding-bottom: 0rem;
  width: 90%;
  margin-left: 5%;
  font-size: 2rem;

  ${mq['md']} {
    width: 100%;
    margin-left: 0rem;
  }
`

export const TestimoniesIconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  margin-bottom: 2rem;

  img {
    width: 18rem;
  }
`

export const TestimoniesRow = styled.div`
  background-color: rgb(250, 250, 250);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${mq['md']} {
    flex-direction: column;
  }
`

export const RowImageContainer = styled.div`
  display: flex;
  width: 50%;

  ${mq['md']} {
    width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ${mq['sm']} {
    img {
      width: 100%;
      height: 226px;
    }
  }
`

export const RowTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 5rem;

  ${mq['xxl']} {
    font-size: 1.75rem;
  }

  ${mq['md']} {
    width: 100%;
  }

  span {
    font-size: 3rem;
    font-weight: 500;
    color: #b9b9b9;
    text-align: right;
    margin-top: 1rem;
  }
`

export const RowReverse = styled.div`
  background-color: rgb(250, 250, 250);
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${mq['md']} {
    flex-direction: column;
  }
`

export const RowReverseImageContainer = styled.div`
  display: flex;
  width: 50%;

  ${mq['md']} {
    width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ${mq['sm']} {
    img {
      width: 100%;
      height: 226px;
    }
  }
`

export const RowReverseTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 5rem;

  ${mq['xxl']} {
    font-size: 1.75rem;
  }

  ${mq['md']} {
    width: 100%;
  }

  span {
    font-size: 3rem;
    font-weight: 500;
    color: #b9b9b9;
    text-align: right;
    margin-top: 1rem;
  }
`

export const CallToActionSection = styled.section`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  color: #213054;
  margin-bottom: 5rem;
  margin-top: 3rem;
  width: 90%;
  margin-left: 5%;

  h1 {
    font-size: 6.5rem;
    padding-top: 12rem;
    text-align: center;
  }

  h4 {
    font-size: 3.1rem;
    font-weight: 400;
    margin-top: 1rem;
    text-align: center;

    span {
      color: #0080fa;
    }
  }
  ${mq['xxl']} {
    h1 {
      font-size: 6rem;
    }
  }
`
export const CallToActionImageContainer = styled.div`
  margin-top: 5rem;
  display: flex;
  align-items: center;
  background-image: url(${ManWithGlobe});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 20%;
  width: 100%;
  height: 80rem;

  ${mq['md']} {
    height: 40rem;
    background-size: cover;
  }

  ${mq['xxl']} {
    h1 {
      font-size: 5rem;
    }

    h4 {
      font-size: 2.5rem;
    }
  }

  ${mq['sm']} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`

export const SubscriptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;

  ${mq['xxl']} {
    justify-content: space-evenly;
  }

  ${mq['md']} {
    margin-top: 0rem;
  }
`

export const Subscription = styled.div`
  display: flex;
  flex-direction: column;
  width: 64rem;
  margin-right: 5rem;
  background-color: rgba(255, 255, 255, 0.7);

  ${mq['xxl']} {
    margin-right: 0;
    width: 50%;
  }

  ${mq['xl']} {
    margin-right: 0;
    width: 100%;
  }
`

export const SubscriptionRow = styled.div`
  display: flex;
  margin-top: 2.5rem;
`

export const SubscriptionColumnOne = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 30%;
  margin: 2rem;

  ${mq['sm']} {
    margin-right: 0;
    width: 100%;

    img {
      margin-left: -2rem;
      width: 15em;
    }
  }
`

export const SubscriptionColumnTwo = styled.div`
  margin-left: 3rem;

  h3 {
    font-size: 4.1rem;
    font-weight: 400;
  }

  p {
    font-size: 2.75rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-right: 2rem;
  }

  ${mq['xxl']} {
    p {
      font-size: 2.5rem;
    }
  }

  ${mq['xl']} {
    h3 {
      font-size: 3.1rem;
      font-weight: 400;
    }

    p {
      font-size: 2rem;
    }
  }

  ${mq['sm']} {
    margin-right: 3rem;
    margin-left: 1rem;

    h3 {
      font-size: 1.9rem;
    }

    p {
      font-size: 1.6rem;
    }
  }
`

export const AppLinksContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  margin-left: 4rem;
  margin-right: 4rem;

  h5 {
    font-size: 2rem;
    color: #213054;

    ${mq['sm']} {
      font-size: 1.5rem;
      margin-right: 0.5rem;
    }
  }
`

export const StoreIconContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SmallIcon = styled.img`
  height: 3rem;
`

export const AppStoreText = styled.span`
  color: #0080fa;
  font-size: 2.1rem;
  margin-left: 1rem;
  margin-bottom: 0.2rem;

  a {
    text-decoration: none;
    color: #0080fa;
  }

  ${mq['sm']} {
    font-size: 1.4rem;
  }
`

export const PerfectAccentSection = styled.section`
  display: flex;
  flex-direction: column;
  background-color: rgb(250, 250, 250);
  width: 100%;
  margin-left: 0%;
  margin-top: 15rem;
  margin-bottom: 0rem;

  ${mq['xxl']} {
    justify-content: space-around;
    margin-top: 10rem;
  }

  ${mq['md']} {
    flex-direction: column;
    align-items: center;
    margin-top: 0rem;
    width: 100%;
    margin-left: 0%;
  }
`

export const PerfectAccentRow = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-top: 5rem;

  ${mq['md']} {
    flex-direction: column;
  }
`

export const PerfectAccentLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  height: 100%;
  color: #213054;
  margin-left: 5rem;
  margin-right: 5rem;
  font-size: 2rem;
  text-align: left;
  font-weight: 400;
`

export const PerfectAccentRightContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  padding-right: 3%;

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  ${mq['md']} {
    padding-left: 3%;
  }
`

export const PerfectAccentTextContainer = styled.div`
  width: 70%;

  h3 {
    font-size: 2.5rem;
    font-weight: 700;
    width: 100%;
  }

  p {
    margin-bottom: 4rem;
  }

  span {
    font-size: 2rem;
    font-weight: 300;
    text-align: left;
    width: 100%;
    color: #0080fa;
  }

  ${mq['xxl']} {
    width: 80%;
    font-size: 1.75rem;

    h3 {
      font-size: 2rem;
    }
  }

  ${mq['xl']} {
    width: 100%;
  }

  ${mq['md']} {
    margin-top: 5rem;
    width: 40rem;
    padding-bottom: 5rem;
  }

  ${mq['sm']} {
    margin-top: 5rem;
    width: 25rem;
    padding-bottom: 5rem;
  }
`

export const PerfectAccentDownloadAppContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 0rem;

  ${mq['xxl']} {
    justify-content: space-evenly;
  }

  ${mq['md']} {
    margin-top: 0rem;
  }
`

export const PerfectAccentInfoContainer = styled.div`
  display: flex;
  align-self: end;
  flex-direction: column;
  justify-content: center;
  width: 59rem;
  background-color: rgba(255, 255, 255, 0.7);

  ${mq['xxl']} {
    margin-right: 0;
    width: 50%;
  }

  ${mq['xl']} {
    margin-right: 0;
    width: 100%;
  }
`

export const PerfectAccentAppRow = styled.div`
  display: flex;
  margin: 3rem;
`

export const PerfectAccentColumnOne = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  margin: 2rem;
`

export const PerfectAccentColumnTwo = styled.div`
  h3 {
    font-size: 4.1rem;
    font-weight: 400;
  }

  p {
    font-size: 3rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-right: 2rem;
  }

  ${mq['xxl']} {
    p {
      font-size: 2.5rem;
    }
  }

  ${mq['xl']} {
    h3 {
      font-size: 3.1rem;
      font-weight: 400;
    }

    p {
      font-size: 2rem;
    }
  }

  ${mq['sm']} {
    h3 {
      font-size: 2.2rem;
    }

    p {
      font-size: 2.1rem;
    }

    img {
      width: 2em;
    }
  }
`

export const AppStoreLinksContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  margin-left: 4rem;
  margin-right: 4rem;

  h5 {
    font-size: 2rem;
    color: #213054;

    ${mq['sm']} {
      font-size: 1.5rem;
      margin-right: 0.5rem;
    }
  }
`
